import { render, staticRenderFns } from "./WaitingListSummary.vue?vue&type=template&id=6e274893&scoped=true"
import script from "./WaitingListSummary.vue?vue&type=script&lang=js"
export * from "./WaitingListSummary.vue?vue&type=script&lang=js"
import style0 from "./WaitingListSummary.vue?vue&type=style&index=0&id=6e274893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e274893",
  null
  
)

export default component.exports